appInitialize.$inject = [
  '$rootScope',
  '$location',
  'moment',

  // Angular downgraded service
  'abilityService',
  'sessionService',
  'translateService',
  'breadCrumbsService',
];

function appInitialize(
  $rootScope,
  $location,
  moment,

  // Angular downgraded service
  abilityService,
  sessionService,
  translateService,
  breadCrumbsService
) {
  $rootScope.$on('$routeChangeStart', function (event, current) {
    let currentRoute = current.$$route;

    if (!currentRoute) return;

    // $rootScope.$broadcast('listPermissions'); /// emit event, received in ability directive

    jQuery('html, body').animate({ scrollTop: 0 }, 200); // $ replace with javascript

    if (currentRoute.pageTitle) {
      // Title tag
      document.title = translateService.instant(currentRoute.pageTitle) + ' | TIM';
    }

    const isLogged = sessionService.isLoggedIn();

    // Anon access
    if (currentRoute.authReq && !isLogged) {
      $location.path('/ng/login');

      return;
    }

    // Breadcrumbs
    const breadcrumbs = [];
    const breadcrumb = currentRoute.breadcrumb;

    if (breadcrumb) {
      breadcrumbs.push({
        label: breadcrumb.label,
        parent: breadcrumb.parent,
        ajs: breadcrumb.ajs,
      });
    }

    breadCrumbsService.setBreadCrumbs(breadcrumbs);

    // !important when refreshing
    const userLang = sessionService.getUserLanguage();
    const momentLocale = moment.locale(); // ['en', 'de', 'es'] It takes the last lang on refresh

    // console.log(userLang.code);
    // console.log(momentLocale);

    if (userLang.code !== momentLocale) {
      moment.locale(userLang.code);
    }

    if (currentRoute.accessPermission && isLogged) {
      if (!abilityService.can(currentRoute.accessPermission)) {
        $location.path('/');
      }

      if (currentRoute.permissionType) {
        if (!abilityService.canFeature(currentRoute.permissionType).permitted) {
          $location.path('/');
        }
      }
    }
  });
}

export default appInitialize;

// translateService.get(currentRoute.pageTitle).subscribe((title) => {
//   document.title = title + ' | TIM';
// });
